module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9n1n3r6n-405bf3b61128420fb735d6c324db70fe.svg";